import domReady from '../utils/domReady.js'

domReady(() => {
  $('#contact-form').submit(function (ev) {
    $(this).addClass('submitting')
  })
})
